/* MIS Industrial — predictive-search.js
   Accessible combobox for the header search. Fetches the predictive-search
   section via Shopify's suggest endpoint + Section Rendering API. The plain
   form submit remains the baseline — this only adds suggestions. */

document.querySelectorAll('[data-predictive-search-form]').forEach((form) => {
  const input = form.querySelector('[data-predictive-input]');
  const panel = form.querySelector('[data-predictive-results]');
  const status = form.querySelector('[data-predictive-status]');
  const baseUrl = form.dataset.predictiveUrl;
  if (!input || !panel || !baseUrl) return;

  let debounceTimer = null;
  let controller = null;
  let activeIndex = -1;

  const options = () => Array.from(panel.querySelectorAll('[role="option"]'));

  function close() {
    panel.hidden = true;
    panel.innerHTML = '';
    input.setAttribute('aria-expanded', 'false');
    input.removeAttribute('aria-activedescendant');
    activeIndex = -1;
  }

  function setActive(index) {
    const opts = options();
    if (!opts.length) return;
    activeIndex = (index + opts.length) % opts.length;
    opts.forEach((opt, i) => {
      opt.setAttribute('aria-selected', i === activeIndex ? 'true' : 'false');
    });
    const active = opts[activeIndex];
    input.setAttribute('aria-activedescendant', active.id);
    active.scrollIntoView({ block: 'nearest' });
  }

  async function fetchSuggestions(query) {
    if (controller) controller.abort();
    controller = new AbortController();
    const url =
      `${baseUrl}?q=${encodeURIComponent(query)}` +
      '&resources[type]=product,query,collection,page' +
      '&resources[limit]=8' +
      '&resources[options][unavailable_products]=last' +
      '&resources[options][fields]=title,product_type,variants.title,variants.sku,vendor' +
      '&section_id=predictive-search';
    try {
      const res = await fetch(url, { signal: controller.signal });
      if (!res.ok) return;
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('.predictive__panel');
      if (fresh) {
        panel.replaceChildren(fresh);
        panel.hidden = false;
        input.setAttribute('aria-expanded', 'true');
        activeIndex = -1;
        if (status) {
          const count = options().length;
          status.textContent = count > 0 ? `${count} suggestions available` : '';
        }
      } else {
        close();
      }
    } catch (err) {
      if (err.name !== 'AbortError') close();
    }
  }

  input.addEventListener('input', () => {
    const query = input.value.trim();
    window.clearTimeout(debounceTimer);
    if (query.length < 2) { close(); return; }
    debounceTimer = window.setTimeout(() => fetchSuggestions(query), 250);
  });

  input.addEventListener('keydown', (e) => {
    if (panel.hidden) return;
    switch (e.key) {
      case 'ArrowDown':
        e.preventDefault();
        setActive(activeIndex + 1);
        break;
      case 'ArrowUp':
        e.preventDefault();
        setActive(activeIndex - 1);
        break;
      case 'Enter': {
        if (activeIndex >= 0) {
          const active = options()[activeIndex];
          const link = active && active.querySelector('a');
          if (link) { e.preventDefault(); window.location.href = link.href; }
        }
        break;
      }
      case 'Escape':
        close();
        break;
      case 'Tab':
        close();
        break;
    }
  });

  document.addEventListener('click', (e) => {
    if (!form.contains(e.target)) close();
  });
});
